import { TranslationDictionary } from '@plandi/common'
import * as Yup from 'yup'

export const changeEmailValidationSchema = (
  translate?: TranslationDictionary['data']
) => {
  return Yup.object().shape({
    email: Yup.string()
      .email(translate?.['wrong-email'] ?? 'Неправильный email')
      .required(translate?.['required-field'] ?? 'Обязательное поле'),
    currentPassword: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(6, translate?.['password-is-short'] ?? 'Пароль слишком короткий')
  })
}

export const changePasswordValidationSchema = (
  translate?: TranslationDictionary['data']
) => {
  return Yup.object().shape({
    newPassword: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(6, translate?.['password-is-short'] ?? 'Пароль слишком короткий'),
    currentPassword: Yup.string()
      .required(translate?.['required-field'] ?? 'Обязательное поле')
      .min(6, translate?.['password-is-short'] ?? 'Пароль слишком короткий')
  })
}
